import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './appviews/pages/home/home.component';
import { AboutComponent } from './appviews/pages/about/about.component';
import { FaqComponent } from './appviews/pages/faq/faq.component';
import { ErrorComponent } from './appviews/pages/error/error.component';
import { ContactComponent } from './appviews/pages/contact/contact.component';
import { PrivacyComponent } from './appviews/pages/privacy/privacy.component';
import { TermsComponent } from './appviews/pages/terms/terms.component';
import { CartComponent } from './appviews/shop/cart/cart.component';
import { CheckoutComponent } from './appviews/shop/checkout/checkout.component';
import { TrackingComponent } from './appviews/shop/tracking/tracking.component';
import { TrackingDetailsComponent } from './appviews/shop/tracking-details/tracking-details.component';
import { ProductDetailsComponent } from './appviews/shop/product-details/product-details.component';
import { ShopComponent } from './appviews/shop/shop/shop.component';
import { SubcategoryComponent } from './appviews/shop/subcategory/subcategory.component';
import { PaymentResultComponent } from './appviews/shop/payment-result/payment-result.component';
import { OfferShopComponent } from './appviews/shop/offer-shop/offer-shop.component';
import { OccasionShopComponent } from './appviews/shop/occasion-shop/occasion-shop.component';
import { ItemsComponent } from './common/items/items.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'about', component: AboutComponent },
    { path: 'discounts', component: OfferShopComponent },
    { path: 'occasions', component: OccasionShopComponent },
    { path: 'cart', component: CartComponent },
    { path: 'checkout', component: CheckoutComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'tracking', component: TrackingComponent },
    { path: 'tracking_details', component: TrackingDetailsComponent },
    { path: 'shop', component: ShopComponent },
    { path: 'product-details', component: ProductDetailsComponent },
    { path: 'subcategory', component: SubcategoryComponent },
    { path: 'payment_result', component: PaymentResultComponent },
    { path: 'items_screen', component: ItemsComponent },






    //{ path: 'team', component: TeamComponent },
    //{ path: 'how-it-works', component: HowItWorksComponent },
    //{ path: 'categories-one', component: CategoriesOneComponent },
    //{ path: 'categories-two', component: CategoriesTwoComponent },
    //{ path: 'listing-one', component: ListingOneComponent },
    //{ path: 'listing-two', component: ListingTwoComponent },
    //{ path: 'listing-three', component: ListingThreeComponent },
    //{ path: 'listing-four', component: ListingFourComponent },
    //{ path: 'listing-five', component: ListingFiveComponent },
    //{ path: 'listing-details', component: ListingDetailsComponent },
    //{ path: 'blog-one', component: BlogOneComponent },
    //{ path: 'blog-two', component: BlogTwoComponent },
    //{ path: 'blog-three', component: BlogThreeComponent },
    //{ path: 'blog-four', component: BlogFourComponent },
    //{ path: 'blog-five', component: BlogFiveComponent },
    //{ path: 'blog-details-one', component: BlogDetailsOneComponent },
    //{ path: 'blog-details-two', component: BlogDetailsTwoComponent },
    //{ path: 'blog-details-three', component: BlogDetailsThreeComponent },
    //{ path: 'faqs', component: FaqComponent },
    //{ path: 'error', component: ErrorComponent },
    //{ path: 'coming-soon', component: ComingSoonComponent },
    //{ path: 'login', component: LoginComponent },
    //{ path: 'register', component: RegisterComponent },

    { path: '**', component: ErrorComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
